import React from 'react';

const DefaultIcon = (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v4" />
    <circle cx="12" cy="16" r="0.6" fill="currentColor" />
  </svg>
);

/**
 * EmptyState - centered placeholder used inside section cards.
 *
 * Props:
 *   icon     node     optional, defaults to a neutral info circle
 *   title    string
 *   message  node
 *   action   node     usually a <Button>
 */
export default function EmptyState({ icon, title, message, action }) {
  return (
    <div className="billing-admin__empty">
      <div className="billing-admin__empty-icon">{icon || DefaultIcon}</div>
      {title && <h4 className="billing-admin__empty-title">{title}</h4>}
      {message && <p className="billing-admin__empty-sub">{message}</p>}
      {action}
    </div>
  );
}
